<template>
  <svg id="Icons" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"/>
    <path class="cls-1" d="M15.293,13.293,13,15.586V6a1,1,0,0,0-2,0v9.586L8.707,13.293a1,1,0,1,0-1.414,1.414l4,4a1,1,0,0,0,1.414,0l4-4a1,1,0,0,0-1.414-1.414Z"/>
  </svg>
</template>
